<template>
  <v-popover
      placement="bottom"
      offset="11"
      open-group="transaction-remove-popover"
      popoverClass="transaction-remove-popover">
    <div class="flex items-center text-text-ternary
              cursor-pointer
              hover:text-red group">
      <IconTrash class="mr-4 transition duration-200"/>
      <span class="text-2sm transition duration-200 border-b border-dashed border-border group-hover:border-red">
      <slot name="text"/>
    </span>
    </div>
    <template slot="popover">
      <div class="col-span-2">
        <slot name="popover">
          <p class="text-text text-lg font-bold">{{ $t('decision') }}</p>
        </slot>
      </div>
      <div class="col-span-2 space-y-4">
        <BaseButton size="sm"
                    class="w-full whitespace-nowrap"
                    v-close-popover
                    :disabled="!!submitted"
                    @click="$emit('confirm',true)"
                    theme="red">{{ $t('accountAndTransactions') }}
        </BaseButton>
        <BaseButton size="sm"
                    class="w-full"
                    @click="$emit('confirm',false)"
                    v-close-popover
                    :disabled="!!submitted"
                    theme="red">{{ $t('onlyAccount') }}
        </BaseButton>
        <BaseButton size="sm"
                    class="w-full"
                    v-close-popover
                    :disabled="!!submitted"
                    theme="white">{{ $t('cancel') }}
        </BaseButton>
      </div>
    </template>
  </v-popover>
</template>

<script>
import IconTrash from "@/components/icons/IconTrash";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "AccountArchiveBtn",
  components: {BaseButton, IconTrash},
  props: {
    submitted: {
      type: Boolean
    }
  },
  i18n: {
    messages: {
      en: {
        decision: 'By deleting the account you want:',
        accountAndTransactions: 'Delete account and transactions',
        onlyAccount: 'Delete only account',
        cancel: 'Cancel'
      },
      ru: {
        decision: 'Удаляя счет вы хотите:',
        accountAndTransactions: 'Удалить счет и транзакции',
        onlyAccount: 'Удалить только счет',
        cancel: 'Отменить'
      }
    }
  }
}
</script>
